import { useStyles } from '@archipro-design/aria';
import * as S from './DirectoryHeader.style';

export interface HeroContentProp {
    content?: string;
}

const FALLBACK_CONTENT = `Be informed and make the best decisions for your project. We bring you insights and interviews from those at the forefront of architecture and construction.`;

const HeroContent: React.FC<HeroContentProp> = ({ content }) => {
    const { css } = useStyles();

    return (
        <div
            className={css(S.HeroContent)}
            dangerouslySetInnerHTML={{
                __html: content ?? FALLBACK_CONTENT,
            }}
        ></div>
    );
};

export default HeroContent;
